import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import { injectScript } from '@cognitoforms/utils/utils';
import { markRaw } from 'vue';

export const namespace = 'PublicForm';
/**
 * Inject the public form handle
 * @param formId The form id
 * @param apiKey The org's public key
 * @returns A promise
 */
export async function injectPublicFormApi(apiKey: string, targetElement: HTMLElement = null) {
	return injectScript(`/svc/load-form/script/seamless.js?cachehash=${CognitoConfiguration.CacheHash}`, {
		targetElement,
		dataProperties: {
			namespace,
			key: apiKey
		}
	}).then(() => {
		markRaw(window[namespace]);
	});
}

export function removePublicFormApi() {
	// Remove stylesheets injected by form client
	document.querySelectorAll('style.cog-style').forEach(tag => tag.remove());

	delete window[namespace];
	document.querySelector('script[data-namespace="PublicForm"]')?.remove();
}